// Personel sabitleri

export const EMPLOYEE_DOCS = [
  { key: 'sgk_ise_giris', label: 'SGK İşe Giriş', hasDate: true },
  { key: 'isg_egitimi', label: 'İSG Eğitimi', hasDate: true, hasValidity: true },
  { key: 'saglik_raporu', label: 'Sağlık Raporu', hasDate: true, hasValidity: true },
  { key: 'mesleki_yeterlilik', label: 'Mesleki Yeterlilik', hasDate: true, hasValidity: true },
  { key: 'mesleki_egitim', label: 'Mesleki Eğitim', hasDate: false },
  { key: 'kkd_zimmet', label: 'KKD Zimmet', hasDate: false },
];

export const DOC_STATUS_OPTIONS = [
  { value: 'onay', label: 'Onay', color: 'bg-emerald-100 text-emerald-700', icon: 'Check' },
  { value: 'eksik', label: 'Eksik', color: 'bg-rose-100 text-rose-700', icon: 'X' },
  { value: 'beklemede', label: 'Beklemede', color: 'bg-amber-100 text-amber-700', icon: 'Clock' },
  { value: 'kapsam_disi', label: 'Kapsam Dışı', color: 'bg-slate-100 text-slate-700', icon: 'MinusCircle' },
];

export const getDocStatusColor = (status) => {
  const option = DOC_STATUS_OPTIONS.find(o => o.value === status);
  return option?.color || 'bg-slate-100 text-slate-700';
};

export const getDocStatusLabel = (status) => {
  const option = DOC_STATUS_OPTIONS.find(o => o.value === status);
  return option?.label || status;
};
